import { render, staticRenderFns } from "./setStaff.vue?vue&type=template&id=34662942&"
import script from "./setStaff.vue?vue&type=script&lang=ts&"
export * from "./setStaff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports